module.exports = __webpack_public_path__ + "static/Summaries-6ec81b6b3686ff054a7c974300f10e7b.png";